'use client'

import { useCallback, useMemo } from 'react'
// eslint-disable-next-line no-restricted-imports
import { Trans as TransI18Next, useTranslation as useReactI18Next } from 'react-i18next'
import type { NamespaceKey, UseTranslationReturnType } from './types'

export function useTranslation<NSs extends NamespaceKey>(
  namespaces: NSs[],
): UseTranslationReturnType<NSs> {
  const { t: originalT, i18n } = useReactI18Next(namespaces)

  const t = useCallback<UseTranslationReturnType<NSs>['t']>(
    (key, options) => originalT(key, options),
    [originalT],
  )

  const Trans = useCallback<UseTranslationReturnType<NSs>['Trans']>(
    ({ i18nKey, values, components }) => (
      <TransI18Next i18nKey={i18nKey} values={values} components={components} />
    ),
    [],
  )

  return useMemo(() => ({ t, Trans, i18n }), [t, Trans, i18n])
}
